import { getPath } from '@/router/common'

const baseUrl = {
  title: '落地分流',
  path: 'landingDispatch'
}

export default [
  {
    path: getPath('index', baseUrl),
    name: 'ddfl_index',
    component: () =>
      import(
        /* webpackChunkName: "landingDispatch_ddfl_index" */ '@/views/landingDispatch/index.vue'
      ),
    meta: {
      title: '调度分流'
    }
  },
  {
    path: getPath('moreTypesOrder', baseUrl),
    name: 'more_types_order',
    component: () =>
      import(
        /* webpackChunkName: "landingDispatch_more_types_order" */ '@/views/landingDispatch/moreTypesOrder/index.vue'
      ),
    meta: {
      title: '多类型分流订单'
    }
  },
  {
    path: getPath('detail', baseUrl),
    name: 'detail',
    component: () =>
      import(
        /* webpackChunkName: "landingDispatch_detail" */ '@/views/landingDispatch/detail/index.vue'
      ),
    meta: {
      title: '分流信息'
    }
  },
  {
    path: getPath('diverFeeAudit', baseUrl),
    name: 'diverFeeAudit',
    component: () =>
      import(
        /* webpackChunkName: "landingDispatch_diverFeeAudit" */ '@/views/landingDispatch/driverFeeAudit.vue'
      ),
    meta: {
      title: '司机费用审核'
    }
  }
]
